import firebase from "./firebase";
import { localStore } from "./localStorage";

const deleteCollection = async (collectionPath) => {
  const batchSize = 10;
  const db = firebase.firestore();
  const collectionRef = db.collection(collectionPath);
  const query = collectionRef.orderBy("__name__").limit(batchSize);

  return new Promise((resolve, reject) => {
    deleteQueryBatch(db, query, resolve).catch(reject);
  });
};

const deleteQueryBatch = async (db, query, resolve) => {
  const snapshot = await query.get();

  const batchSize = snapshot.size;
  if (batchSize === 0) {
    // When there are no documents left, we are done
    resolve();
    return;
  }

  // Delete documents in a batch
  const batch = db.batch();
  snapshot.docs.forEach((doc) => {
    batch.delete(doc.ref);
  });
  await batch.commit();

  // Recurse on the next process tick, to avoid
  // exploding the stack.
  process.nextTick(() => {
    deleteQueryBatch(db, query, resolve);
  });
};

//Updates time of session to current time
const updateTime = async() => {
  try{
    const id = localStore.getSession();
    const db = firebase.firestore();
    let session = db.collection("sessions").doc(id);
    await session.set({
      time: Math.floor(new Date().getTime() / 1000),
    },{merge: true});

    return true;

  }
  catch(err){
    return err;
  }
  
};


//Updates session status
const updateStatus = async(status) => {
  try{
    const id = localStore.getSession();
    const db = firebase.firestore();
    let session = db.collection("sessions").doc(id);
    await session.set({
      time: Math.floor(new Date().getTime() / 1000),
      status: status
    },{merge: true});
    return true;
  }
  catch(err){
    return err;
  }
 
};

export { deleteCollection, updateTime, updateStatus};
